import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, Link } from "@mui/material";
import Web3 from "web3";

import DashboardList from "../../Components/DashboardList";
import DashboardMenuForDesktop from "../../Components/DashboardMenu";
import DashboardCard from '../../Components/DashboardCard';
import Loader from "../../Components/ErroBook/loader";
import NtError from "../../Components/ErroBook/ntErro";

var web3;
var deciConvert = 1e9;
var osAdd;
var osAbi;
var osContract
var stakeAdd;
var stakeAbi;
var stakeContract
var DistributorAdd;
var DistributorAbi;
var DistributorContract


const Stake = () => {

    const [useDefaultAccount, setDefaultAccount] = useState();
    const [usebuttonText, setbuttonText] = useState('Connect Wallet');
    const [useTokenBalance, setTokenBalance] = useState();
    const [useStakedBalance, setStakedBalance] = useState('0');
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    // States for this page
    const [useShowWalltetButton, setShowWalltetButton] = useState(true);
    const [useNextReward, setNextReward] = useState('0');
    const [useRewardYield, setRewardYield] = useState('0');
    const [useRoi, setRoi] = useState('0');
    const [useAmount, setAmount] = useState()
    const [useAmountError, setAmountError] = useState()
    const [useTotalStakedValue, setTotalStakedValue] = useState('0')
    const [useCurrentIndex, setCurrentIndex] = useState('0')
    const [useApy, setApy] = useState('0')
    const [useApprove, setApprove] = useState(true)
    
    

    useEffect(()=> {
        connectWallet();
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[useError]);

    /***************************************************
    *
    *    Slicing function
    *
    ****************************************************/
    const conciseWallet = (value) => {
        const intvalue = value.toString();
        if( intvalue != ""){
            const start_char = value.toString().substring(0,4)+".....";
            const end_char = value.toString().substr(value.length - 3);
            setShowWalltetButton(false)
            setbuttonText("Connected " + start_char + end_char)
        }else{
            setErrorType('walletNotConnected')
            setError(true)
            setbuttonText("Connect Wallet")
        }
    }

    /***************************************************
    *
    *    Numaric amount function
    *
    ****************************************************/
    
    const numaricAmount = (num,digit) => {
        var testnumber = Number.parseFloat(num).toFixed(digit);
        return testnumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    
    /***************************************************
    *
    *    update account, will cause component re-render
    *
    ****************************************************/
	const accountChangedHandler = (newAccount) => {
		setDefaultAccount(newAccount);
        conciseWallet(newAccount);
	}

    // Change network handling 
    try{
        window.ethereum.on('chainChanged', (_chainId => {
            if ( _chainId == "0x38") {
                console.log('you are on BSC', _chainId)
                window.location.reload();
            }else if ( _chainId == "0x61") {
                console.log('you are on BSC Test Net', _chainId)
                window.location.reload();
            }else{
                console.log('Wrong network Connected', _chainId)
                setErrorType('wrongNetwork')
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Updated Address error ', error)
    }

    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            accountChangedHandler(_mAddress.toString())
            setErrorType('walletChanged')
            setError(true)
            console.log('Updated Address ', _mAddress)
        }));
       
    } catch (error) {
        console.log('Updated Address error ', error)
    }
    
    // onClick Connecting Metamask
    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){
            web3 = new Web3(window.ethereum);
           
            //OhmniShiba contract 
            osAdd = "0xf22e419A6827ed431c97A778b35A719447BB2c86";
            osAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"previousTWAPEpochPeriod","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newTWAPEpochPeriod","type":"uint256"}],"name":"TWAPEpochChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousTWAPOracle","type":"address"},{"indexed":true,"internalType":"address","name":"newTWAPOracle","type":"address"}],"name":"TWAPOracleChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newTWAPSource","type":"address"}],"name":"TWAPSourceAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"removedTWAPSource","type":"address"}],"name":"TWAPSourceRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"_burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newTWAPSourceDexPool_","type":"address"}],"name":"addTWAPSource","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newTWAPEpochPeriod_","type":"uint256"}],"name":"changeTWAPEpochPeriod","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newTWAPOracle_","type":"address"}],"name":"changeTWAPOracle","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"twapSourceToRemove_","type":"address"}],"name":"removeTWAPSource","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"vault_","type":"address"}],"name":"setVault","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"twapEpochPeriod","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"twapOracle","outputs":[{"internalType":"contract ITWAPOracle","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"vault","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
            osContract = new web3.eth.Contract( osAbi , osAdd );

            //Stake contract 
            stakeAdd = "0xA37248865fE6cfE78dFe41e2aD000c39B7b436FB"
            stakeAbi = [{"inputs":[{"internalType":"address","name":"_LOVE","type":"address"},{"internalType":"address","name":"_KISS","type":"address"},{"internalType":"uint256","name":"_epochLength","type":"uint256"},{"internalType":"uint256","name":"_firstEpochNumber","type":"uint256"},{"internalType":"uint256","name":"_firstEpochBlock","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"inputs":[],"name":"KISS","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"LOVE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_recipient","type":"address"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"contractBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"distributor","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"epoch","outputs":[{"internalType":"uint256","name":"length","type":"uint256"},{"internalType":"uint256","name":"number","type":"uint256"},{"internalType":"uint256","name":"endBlock","type":"uint256"},{"internalType":"uint256","name":"distribute","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"forfeit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"giveLockBonus","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"index","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"locker","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manager","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"pushManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"rebase","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"returnLockBonus","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Staking.CONTRACTS","name":"_contract","type":"uint8"},{"internalType":"address","name":"_address","type":"address"}],"name":"setContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_warmupPeriod","type":"uint256"}],"name":"setWarmup","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"address","name":"_recipient","type":"address"}],"name":"stake","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"toggleDepositLock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalBonus","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"bool","name":"_trigger","type":"bool"}],"name":"unstake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"warmupContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"warmupInfo","outputs":[{"internalType":"uint256","name":"deposit","type":"uint256"},{"internalType":"uint256","name":"gons","type":"uint256"},{"internalType":"uint256","name":"expiry","type":"uint256"},{"internalType":"bool","name":"lock","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"warmupPeriod","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]
            stakeContract = new web3.eth.Contract( stakeAbi , stakeAdd );
            console.log('stakeContract ', stakeContract)

            //Distributor contract 
            DistributorAdd = "0x895416D9AB8cC23Dd16b097f6EaB6B7b70acAaa3"
            DistributorAbi = [{"inputs":[{"internalType":"address","name":"_treasury","type":"address"},{"internalType":"address","name":"_love","type":"address"},{"internalType":"uint256","name":"_epochLength","type":"uint256"},{"internalType":"uint256","name":"_nextEpochBlock","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"inputs":[],"name":"LOVE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_recipient","type":"address"},{"internalType":"uint256","name":"_rewardRate","type":"uint256"}],"name":"addRecipient","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"adjustments","outputs":[{"internalType":"bool","name":"add","type":"bool"},{"internalType":"uint256","name":"rate","type":"uint256"},{"internalType":"uint256","name":"target","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"distribute","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"epochLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"info","outputs":[{"internalType":"uint256","name":"rate","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nextEpochBlock","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"nextRewardAt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_recipient","type":"address"}],"name":"nextRewardFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"policy","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullPolicy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newPolicy_","type":"address"}],"name":"pushPolicy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"address","name":"_recipient","type":"address"}],"name":"removeRecipient","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renouncePolicy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"bool","name":"_add","type":"bool"},{"internalType":"uint256","name":"_rate","type":"uint256"},{"internalType":"uint256","name":"_target","type":"uint256"}],"name":"setAdjustment","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"treasury","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
            DistributorContract = new web3.eth.Contract( DistributorAbi , DistributorAdd );

            web3.eth.getBalance(stakeAdd).then(balance => {
                // Get OhmniSHiba price                
                fetch('https://api.coingecko.com/api/v3/coins/solana').then(result => {
                    result.json().then(data => {
                        let MPrice = data.market_data.current_price.usd;
                        setTotalStakedValue((balance/deciConvert)*MPrice)
                        console.log('setTotalStakedValue: ', balance/deciConvert)
                    })
                });
            })
            .catch(error => {
                console.log(error.message);
            });

            stakeContract.methods.index().call().then( result => {
                // setStakedBalance(result)
                setCurrentIndex(result)
            })
            .catch (error => {
                console.log('Stakeing balance error', error)
            })

            stakeContract.methods.epoch().call().then( stakingReward => {
                osContract.methods.totalSupply().call().then( result => {
                    let balOfTS = result/deciConvert
                    osContract.methods.balanceOf("0x0000000000000000000000000000000000000000").call().then( burnResult => {
                        let balOfCS = balOfTS-burnResult
                        let stakingRebase = numaricAmount(stakingReward[3]/balOfCS,0)
                        const stakingAPY = Math.pow(1 + stakingRebase, 365 * 3) - 1;
                        const stakingROI = Math.pow(1 + stakingRebase, 5 * 3) - 1;
                        setApy(numaricAmount(stakingAPY,2))
                        setRoi(numaricAmount(stakingROI/deciConvert,2))
                        console.log('epoch: ', stakingROI)
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                    })
                })
            })
            .catch (error => {
                console.log('user Balance', error)
            })

            // const epoch = await stakingContract.epoch();
            // const stakingReward = epoch.distribute;
            // const circ = await ohmniContract.circulatingSupply();
            // const stakingRebase = Number(stakingReward.toString()) / Number(circ.toString());
            // const fiveDayRate = Math.pow(1 + stakingRebase, 5 * 3) - 1;
            // const stakingAPY = Math.pow(1 + stakingRebase, 365 * 3) - 1;
            
            








            //get connected wallet address
            try {
                let userBal;
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    accountChangedHandler(_account.toString());
                    
                    stakeContract.methods.warmupInfo(_account.toString()).call().then( result => {
                        setStakedBalance(result[0]/deciConvert)
                    })
                    .catch (error => {
                        console.log('Stakeing balance error', error)
                    })
                    stakeContract.methods.index().call().then( result => {
                        // setStakedBalance(result)
                        setCurrentIndex(result)
                    })
                    .catch (error => {
                        console.log('Stakeing balance error', error)
                    })
                    osContract.methods.allowance(_account.toString(),stakeAdd).call().then( result => {
                        if( result > 1 ){
                            setApprove(false)
                        }else{
                            setApprove(true)
                        }  
                    })
                    .catch (error => {
                        console.log('Allowance error', error)
                    })
                    osContract.methods.balanceOf(_account.toString()).call().then( result => {
                        setTokenBalance(result/deciConvert)
                        userBal = result/deciConvert
                        
                        DistributorContract.methods.nextRewardFor(_account.toString()).call().then( result => {
                            let rewardAmount = result/deciConvert
                            setNextReward(rewardAmount)
                            let userTotalBalance = userBal+rewardAmount
                            let countYieldd = ((userTotalBalance-userBal)/userBal)*100
                            console.log('sdfdsfsdf: ', userTotalBalance)
                            setRewardYield(countYieldd)
                        })
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                        setErrorType('maybeWrongNetwork')
                        setError(true)
                    })
                })
                .catch (error => {
                    console.log('user accountChangedHandler', error.code)

                    setErrorType('walletNotConnected')
                    setError(true)
                });
            } catch (error) {
                console.log('Rejected.! ', error)
                setErrorType('noMetamask')
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }
    const handleApprove = () => {        
        setLoader(true)
        osContract.methods.approve(stakeAdd, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
        .send({from: useDefaultAccount}).then( test => {
            osContract.methods.allowance(useDefaultAccount,stakeAdd).call().then( result => {
                if( result > 1 ){
                    setApprove(false)
                }else{
                    setApprove(true)
                }   
                window.location.reload();
                setLoader(false)     
          })
        })
        .catch(error => {
            setLoader(false)
            if(error.code == '4001'){
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
          console.log('Error getting fake data 1234: ' , error);
        });
    }

    const handleStake = () => {
        
        if (useAmount == "" || useAmount <= 0.01 || isNaN(useAmount)){
            setAmountError(true)
            return;
        }
        if(useAmount > useTokenBalance){
            setAmountError(true)
            return;
        }else if(useAmount <= 0){
            setAmountError(true)
            return;
        }
        
        let convertedamounttostr1 = useAmount.toString()
        let convertedamounttostr = web3.utils.toWei(convertedamounttostr1, 'gwei')

        setLoader(true)
        stakeContract.methods.stake(convertedamounttostr,useDefaultAccount)
        .send({ from: useDefaultAccount }).then( result => {
            setLoader(false)
            window.location.reload();
        })
        .catch(error => {
            setLoader(false)
            if(error.code == '4001'){
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
            console.log('Staking error: ' , error);
        });

        // , value: 10 * 1e18
    }
    
    const handleUnstake = () => {
        setLoader(true)
        stakeContract.methods.forfeit()
        .send({ from: useDefaultAccount }).then( result => {
            setLoader(false)
            window.location.reload();
        })
        .catch(error => {
            setLoader(false)
            if(error.code == '4001'){
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
            console.log('Error getting fake data 1234: ' , error.code);
        });

        // , value: 10 * 1e18
    }

    const handleAmount = (val,type) => {
        if( type == 'srch'){
        let valuea = val.target.value.toLowerCase();
        setAmount(valuea)
        if(valuea > useTokenBalance){
            setAmountError(true)
        }else if(valuea <= 0){
            setAmountError(true)
        }else{
            setAmountError(false)
        }
        }else{
        setAmount(val)
        if(val > useTokenBalance){
            setAmountError(true)
        }else if(val <= 0){
            setAmountError(true)
        }else{
            setAmountError(false)
        }
        }
    }
    
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return(
        <div>
            {useError ?
                <NtError 
                    errorType = {useErrorType}
                />
            :
                <span />
            }
            <Grid container className="position-relative">
                
                { useLoader ? 
                    <Loader />
                    :
                    <span />
                }
                <DashboardMenuForDesktop />
                <Grid xs={12} md={2} />
                <Grid 
                    container
                    xs={12}
                    md={10} 
                    style={{backgroundColor: '#1D1D1D',minHeight:'100vh'}}
                    className="py-4 px-4 px-sm-5"
                    alignContent="flex-start"
                >
                    <Grid
                        xs={12}
                        className="text-right pt-4 pb-5"
                    >
                        <Link href="#" onClick={connectWallet} className="Global---menu-nav-btn px-4 py-2 mx-1">
                            {usebuttonText}
                        </Link>
                    </Grid>
                    <DashboardCard 
                        title="APY"
                        detail="TBA"
                        // detail= { useApy + "%"}
                        addClass="a d"
                    />
                    <DashboardCard 
                        title="Total Staked Value"
                        detail= {"$" + (useTotalStakedValue)}
                        addClass="b"
                    />
                    <DashboardCard 
                        title="Current Index"
                        detail= { useCurrentIndex + " Ohmini" }
                        addClass="c e f"
                    />                    
                    <Grid
                        container
                        xs={12}
                        className="Dasboard-card-radius py-4 px-3 mt-5 px-md-5"
                    >
                        <Grid
                            xs={12}
                        >
                            <h2>Single Stake (3, 3)</h2>
                        </Grid>
                        {useShowWalltetButton ? 
                            <Grid
                                xs={12}
                                className="text-center pt-5 pb-4"
                            >
                                <Link href="#" onClick={connectWallet} className="Global---menu-nav-btn px-4 py-2 mx-1">
                                    Connect Wallet
                                </Link>
                                <p className="mt-3 mb-0">Connect your wallet to stake OHMS</p>
                            </Grid>
                        :
                            <Grid
                                xs={12}
                                sm={8}
                                md={9}
                                lg={6}
                                className="mx-auto text-center pt-5 pb-4"
                            >
                                { useApprove ?
                                    <Grid
                                        xs={12}
                                        className="text-center pt-5 pb-4"
                                    >
                                        <Link href="#" onClick={handleApprove} className="Global---menu-nav-btn px-5 py-2 mx-1">
                                            Approve
                                        </Link>
                                    </Grid>
                                :
                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                        <TabContext value={value}>
                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList 
                                                onChange={handleChange} 
                                                aria-label="lab API tabs example"
                                                className="OS---stake--tabs"
                                            >
                                                <Tab label="Stake" value="1" />
                                                <Tab label="Unstake" value="2" />
                                            </TabList>
                                            </Box>
                                            <TabPanel value="1" className="px-0 py-2">
                                                <form className="position-relative">
                                                    { useAmountError ? 
                                                        <p 
                                                            className="text-left d-block text-danger mb-0 position-absolute "  
                                                            style={{top: '-1.3rem', left: '12px', fontSize: '13px'}}
                                                        >
                                                            Select a valid LP Token amount.
                                                        </p>
                                                    :
                                                        <p className="m-0" />
                                                    }
                                                    <div className="OS---form--stake d-md-flex mb-4 mt-4">
                                                        <label className="position-relative">
                                                            <input 
                                                                type="number"
                                                                className="mr-2"
                                                                placeholder="Enter Amount"
                                                                onChange={(event,type) =>handleAmount(event,'srch')}
                                                                value={useAmount}
                                                            />
                                                            <Link
                                                                type="button"
                                                                onClick={(event,type) =>handleAmount(useTokenBalance,'max')}
                                                            >
                                                                Max
                                                            </Link>
                                                        </label>
                                                        <Link 
                                                            href="#" 
                                                            onClick={handleStake}
                                                            className="Global---menu-nav-btn d-inline-block mt-3 mt-md-0 ml-2"
                                                        >
                                                            Stake Ohmini
                                                        </Link>
                                                    </div>
                                                </form>
                                            </TabPanel>
                                            <TabPanel value="2" className="px-0 py-2">
                                            <form className="position-relative">
                                                    { useAmountError ? 
                                                        <p 
                                                            className="text-left d-block text-danger mb-0 position-absolute "  
                                                            style={{top: '-1.3rem', left: '12px', fontSize: '13px'}}
                                                        >
                                                            Select a valid LP Token amount.
                                                        </p>
                                                    :
                                                        <p className="m-0" />
                                                    }
                                                    <div className="OS---form--stake text-center d-md-flex mb-4 mt-4" style={{justifyContent: 'center'}}>
                                                        <Link 
                                                            href="#" 
                                                            onClick={handleUnstake}
                                                            className="Global---menu-nav-btn d-block mt-3 mt-md-0 ml-2"
                                                        >
                                                            Unstake Ohmini
                                                        </Link>
                                                    </div>
                                                </form>
                                            </TabPanel>
                                            <DashboardList 
                                                listTitle="Unstaked Balance"
                                                listValue={numaricAmount(useTokenBalance,3) + " Ohmini"}
                                            />
                                            <DashboardList 
                                                listTitle="Staked Balance"
                                                listValue= {numaricAmount(useStakedBalance,3) + " Ohmini"}
                                            />
                                            <Grid container xs={12} style={{borderBottom: '1px solid #FBE96D', marginBottom:12}}/>
                                            <DashboardList 
                                                listTitle="Next Reward Amount"
                                                listValue= {useNextReward + " Ohmini"}
                                            />
                                            <DashboardList 
                                                listTitle="Next Reward Yield"
                                                listValue={useRewardYield + "%"}
                                            />
                                            <DashboardList 
                                                listTitle="ROI (5-Day Rate)"
                                                listValue= { useRoi + "%" }
                                                />
                                        </TabContext>
                                    </Box>
                                }
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

export default Stake;